<div class="modal-content">
    <!-- Cabeçalho do Modal com título e botão de fechar -->
    <div class="modal-header">
      <h5 class="modal-title">
        Adicionar Documento
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="activeModal.dismiss()"
      ></button>
    </div>
  
    <div class="modal-body p-4">
      <form [formGroup]="documentoForm" (ngSubmit)="adicionarProduto()">
        <input hidden formControlName="projetoId">
        <!-- Campo Nome -->
        <div class="mb-3">
          <label class="form-label">Descrição Documento</label>
          <input
            class="form-control"
            placeholder="Digite uma descrição"
            type="text"
            formControlName="descricao"
            [ngClass]="{
              'is-invalid':
              documentoForm.controls.descricao.errors &&
              documentoForm.get('descricao')?.touched,
            }"
          />
          <div class="invalid-feedback" *ngIf="documentoForm.controls.descricao.errors">
            informe uma descrição
          </div>
          
        </div>

        <div class="mb-3">
            <label for="statusProjeto" class="form-label">
              Tipo De Documento
            </label><span style="color: red;">*</span>
            <select class="form-select" formControlName="tipoDocumento" 
            [ngClass]="{
              'is-invalid':
              documentoForm.controls.tipoDocumento.errors &&
              documentoForm.get('tipoDocumento')?.touched,
            }"
            >
              <option value="" selected disabled>Selecione o tipo</option>
              <!-- <option value="0">Briefing</option> -->
              <option value="4">Contrato</option>
              <option value="2">Orçamento</option>
              <option value="1">Projeto</option>
              <option value="3">Proposta</option>
            </select>
            <div class="invalid-feedback" *ngIf="documentoForm.controls.tipoDocumento.errors">
              Selecione um tipo de documento
            </div>
          </div>
        <!-- Botão de Enviar -->
        <div class="text-end">
          <button type="submit" class="btn btn-success btn-sm w-md">
            Adicionar
          </button>
        </div>
      </form>
    </div>
  </div>
  